import { useState } from "react";
import { api, apiError } from "@/lib/api";

export const FilmSignup = ({ source }) => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault(); setError(""); setState("busy");
    try { await api.post("/film-updates", { email, source }); setState("done"); }
    catch (err) { setError(apiError(err)); setState("idle"); }
  };
  if (state === "done") return <p className="font-blocky text-[9px] text-[#4ade80] tracking-wider mt-3 leading-relaxed" data-testid="film-signup-success">✓ YOU'RE ON THE LIST. WE'LL KEEP YOU POSTED.</p>;
  return (
    <form onSubmit={submit} className="mt-3" data-testid="film-signup-form">
      <p className="font-blocky text-[8px] text-[#9CA3AF] tracking-wider mb-2">GET FILM UPDATES</p>
      <div className="flex gap-2">
        <input type="email" required className="pixel-input !py-2 flex-1 min-w-0" placeholder="you@email.com" value={email}
          onChange={(e) => setEmail(e.target.value)} data-testid="film-signup-email-input" />
        <button type="submit" className="pixel-btn font-blocky !text-[9px] !px-3 whitespace-nowrap" disabled={state === "busy"} data-testid="film-signup-submit-button">
          {state === "busy" ? "..." : "NOTIFY ME"}
        </button>
      </div>
      {error && <p className="pixel-text text-lg text-[#DC2626] mt-1" data-testid="film-signup-error">&gt; {error}</p>}
    </form>
  );
};
